import { Section } from '@efira/ui';
import { useGameInfo } from '../../../api/queries';

/**
 * «Сведения об игре»: показатели хода игры.
 *
 * ОБЪЯВЛЯЕТ ИГРА, ПОКАЗЫВАЕТ ПАНЕЛЬ. В мире `scalar` два десятка скаляров, и
 * половина служебная; какие два-три отвечают на вопрос «что сейчас
 * происходит», знает только автор игры - поэтому состав приходит из
 * `manifest.info`, а подписи из словаря игры (`apps/server`, `worldInfo`).
 *
 * ЧИСЛА БЕРУТСЯ С СЕРВЕРА, А НЕ ИЗ КАДРА: мир авторитетен на сервере, и
 * панель не должна зависеть от того, открыт ли где-то оверлей.
 */
export function GameInfo() {
  const info = useGameInfo(true);
  const rows = info.data?.rows ?? [];

  // Секции нет вовсе, если игре нечего показать: пустая рамка с заголовком
  // сообщает «здесь ничего», занимая место, где могло быть управление.
  if (info.data !== undefined && info.data.running && rows.length === 0) {
    return null;
  }

  return (
    <Section title="Сведения об игре" id="game-info">
      {info.data?.running !== true ? (
        <p className="text-foreground/80 text-sm" data-game-info-idle>
          Игра ещё не пошла: показатели появятся, когда начнётся первый раунд.
        </p>
      ) : (
        <ul className="flex flex-col gap-1">
          {rows.map((row) => (
            <li
              key={row.id}
              data-game-info-row={row.id}
              className="bg-muted/60 flex items-center gap-2 rounded px-2 py-2 text-sm"
            >
              <span className="text-foreground/80 min-w-0 flex-1 truncate">{row.label}</span>
              {/* Моноширинные цифры: число, прыгающее по ширине при каждом
                  обновлении, читается хуже неподвижного. */}
              {/* Нейтральное число - нейтральным цветом: акцент принадлежит
                  состояниям и действиям, а не любому показателю подряд. */}
              <span className="text-foreground font-semibold tabular-nums">{row.value}</span>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}
